import { mapGetters } from 'vuex';
export const resendConfirmationMailMixin = {
  data () {
    return {
      showResendButton: true,
    };
  },
  computed: {
    ...mapGetters([
      'account',
    ]),
  },
  methods: {
    resendConfirmationMail () {
      this.$api().post('/auth/resend_confirmation_email', { email: JSON.stringify(this.account.email) }, {
        params: {
          token: localStorage.getItem('token'),
        },
      })
        .then(response => {
          this.showResendButton = false;
          if (!response.data.ok) {
            response.data.error ? this.$noty.error(response.data.error) : this.$noty.error('Something went wrong');
          } else {
            this.$noty.success('Another confirmation email was just send to your email at ' + this.account.email +
              '<br> If there\'s no email in your Inbox, please, check Spam folder as well. If the problem persist, ' +
              'please, contact Emika Support Team at support@emika.ai', { timeout: 20000 });
          }
        })
        .catch(error => {
          this.$noty.error(error);
        });
    },
  },
};
